export const PERMISSION_RULE = {
    id: 'permission',
    name: "Permission", 
};

export const PROHIBITION_RULE = {
    id: 'prohibition',
    name: "Prohibition", 
};

export const OBLIGATION_RULE = {
    id: 'obligation',
    name: "Obligation", 
};